// extracted by mini-css-extract-plugin
export default {"card":"resumoCard_card__OD8PU","cardContent":"resumoCard_cardContent__kv6+K","cardLink":"resumoCard_cardLink__vYLwu","cardTitle":"resumoCard_cardTitle__DMOx5"};